import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { useTranslation } from "react-i18next";

const PaymentGatewayOptionsPopUp = ({
  showbox,
  handleClose,
  setSelctedValue,
  optionList,
  selectedOption,
  heading = "Select Payment Option",
}) => {
  const [show, setShow] = useState(showbox);
  const { t } = useTranslation();

  useEffect(() => {
    setShow(showbox);
  }, [showbox]);

  const handleSubmit = (values) => {
    console.log("handleSubmit", values)
    const selectedKey = Object.keys(values).find((key) => values[key] === true);
    const selected = optionList.find((option) => option.value === selectedKey);
    if (selected) {
      setSelctedValue(selected);
    }
    handleClose(1);
  };

  const getInitialValues = () => {
    const init = {};
    optionList.forEach((opt) => {
      init[opt.value] = selectedOption?.value === opt.value;
    });
    return init;
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      className="auth-modal modal fade"
      centered
    >
      <Modal.Body>
        <button
          type="button"
          className="btn-close"
          onClick={handleClose}
          aria-label="Close"
        ></button>

        <Formik
          enableReinitialize
          initialValues={getInitialValues()}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div
                className="col-12 justify-content-center align-items-center"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <h3 className="bodyBoldFont mb-4 text-center text-dark">
                  {heading}
                </h3>

                <div className="w-100 d-flex flex-column align-items-start px-3">
                  {optionList.map((opt) => (
                    <label key={opt.value} className="mb-2 w-100">
                      <Field
                        type="radio"
                        name="paymentOption"
                        value={opt.value}
                        checked={values[opt.value]}
                        onChange={() => {
                          optionList.forEach((item) =>
                            setFieldValue(item.value, item.value === opt.value)
                          );
                        }}
                      />{" "}
                      {opt.name}
                    </label>
                  ))}
                </div>

                <button type="submit" className="btn btn-primary mt-4">
                  Confirm
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentGatewayOptionsPopUp;
